<pages-container
  [title]="'main.forumNews'"
  [icon]="'news'">
  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
    (click)="addNews()">
      <span>{{ 'main.add' | translate }}</span>
    </button>
  </div>

  <div main-content class="news-list">
    <div class="table-container" id="newsPage">
      @if (news()?.length) {
        <mat-table class="products-table"
                   #table
                   [dataSource]="news()"
                   (matSortChange)="sortData($event)"
                   matSort>
          <ng-container matColumnDef="text">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.text' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let news" class="customWidthClass">
              <div [innerHTML]="news.text"></div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="date">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.date' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let news" class="customWidthClass">
              <p class="text-truncate">{{ news.date | date: 'dd.MM.yyyy' }}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell class="customWidthClassIcon" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.edit' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let news" class="customWidthClassIcon">
              <mat-icon class="mat-icon-edit" (click)="editNews(news)">edit</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell class="customWidthClassIcon" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.delete' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let news" class="customWidthClassIcon">
              <mat-icon class="mat-icon-delete" (click)="deleteNews(news)">delete</mat-icon>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let news; columns: displayedColumns;"
                   class="banner-row"
                   matRipple>
          </mat-row>
        </mat-table>
        <mat-paginator [length]="pagination()?.total"
                       [pageIndex]="pageIndex()"
                       [pageSize]="perPage()"
                       [pageSizeOptions]="[25, 50, 100]"
                       (page)="handlePageEvent($event)">
        </mat-paginator>
      }
    </div>
    @if (!news()?.length) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
      </div>
    }
  </div>
</pages-container>
